export const PROD_ONE_HOST = "one.atw.net";
export const LOCAL_ONE_HOST = "one.localhost";
export const PROD_ONE_PAGES_PREVIEW = "atw-one.pages.dev";

export function isAtwOnePublicHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_ONE_HOST || h === LOCAL_ONE_HOST;
}

export function isAtwOnePagesPreviewHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_ONE_PAGES_PREVIEW;
}

export function atwOneAppOrigin(): string {
  if (typeof window !== "undefined") {
    return window.location.origin.replace(/\/$/, "");
  }
  return `https://${PROD_ONE_HOST}`;
}

export function atwOneAppUrl(path = "/"): string {
  const normalized = !path || path === "/" ? "/" : path.startsWith("/") ? path : `/${path}`;
  return `${atwOneAppOrigin()}${normalized}`;
}

/** Map monolith `/dashboard/…` paths to One-host short paths. */
export function dashboardPathToOnePath(internalPath: string): string {
  const p = internalPath.startsWith("/") ? internalPath : `/${internalPath}`;
  if (p === "/dashboard" || p === "/dashboard/") return "/";
  if (p.startsWith("/dashboard/")) return p.slice("/dashboard".length) || "/";
  return p;
}

/** Map One-host path to internal dashboard path for API parity docs. */
export function onePathToDashboardPath(onePath: string): string {
  const p = onePath.startsWith("/") ? onePath : `/${onePath}`;
  if (p === "/") return "/dashboard";
  return `/dashboard${p}`;
}
